import * as React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

type Props = {
    num: number;
    hiddenProfile?: boolean;
    isPublish?: number;
    size?: number
};
const PersonnelSkeleton: React.FC<Props> = (props: Props) => {
    const { num, isPublish } = props;
    const numbers = Array.from({ length: num }, (_, index) => index + 1);
    const isPublishArray = isPublish ? Array.from({ length: isPublish }, (_, index) => index + 1) : [];
    return (
        <Stack spacing={1}>
            {isPublishArray.map((_, index: number) => {
                return (
                    <Skeleton key={index} variant="text" height={80} sx={{ fontSize: '4rem' }} />
                )
            })}
            {!props.hiddenProfile && (
                <Skeleton variant="circular" width={150} height={150} />
            )}
            <Skeleton variant="rectangular" width={"100%"} height={props.size || 100} />
            {numbers.map((_, index: number) => {
                return (
                    <Skeleton key={index} variant="rounded" width={"100%"} height={100} />
                )
            })}
        </Stack>
    );
}
export default PersonnelSkeleton